window.jQuery(($) => {
  $("#top_menu_label").click((_e: JQuery.ClickEvent) => {
    const menu = $("#top_menu");
    if (menu.css("display") === "none") {
      menu.css("display", "block");
      menu.position({
        my: "left top",
        at: "left bottom",
        of: "#top_menu_label",
      });
    } else {
      menu.css("display", "none");
    }
  });
});

export {};
